import { Grid, Typography, Box } from '@material-ui/core';
import { Button, ConfirmationButton, StandardDialog, TextField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { AppraisalDetailsV2Store } from 'libs/feature-documents/src/documents/stores/documentForms/appraisalDetailsV2/appraisalDetailsV2Store';

type Props = {
  open: any;
  onClose: any;
  store: AppraisalDetailsV2Store;
  loanId: number;
  lenderId?: number;
  document?: any;
  clientReferenceId?: number;
};

export const AppraisalPaymentLinkModal = observer(
  ({ open, onClose, store, loanId, document, lenderId, clientReferenceId }: Props) => {
    useEffect(() => {
      if (open) {
        store.fetchPaymentLink(loanId, document?.paymentId, lenderId, clientReferenceId);
      } else if (!open && store.paymentLink) {
        store.setPaymentLink('');
      }
    }, [open]);

    const handleCopyLink = () => {
      navigator.clipboard.writeText(store.paymentLink);
    };

    const handleEmailBorrower = () => {
      store.resendPaymentEmail();
    };

    const dialogContent = (
      <Box>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: '24px' }}
        >
          A new payment link has been generated for this valuation
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginBottom: '8px' }}>
              Payment Link
            </Typography>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={8}>
                <TextField
                  value={store.paymentLink}
                  fullWidth
                  variant="outlined"
                  testId="payment-link"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <Button
                  testId="copy-link"
                  color="primary"
                  variant="contained"
                  onClick={handleCopyLink}
                  fullWidth
                  disabled={!store.paymentLink}
                >
                  Copy Link
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginBottom: '8px' }}>
              Borrower Email
            </Typography>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={8}>
                <TextField
                  value={store.recipientEmail || (loanId ? store.resolvedBorrowerEmail : '')}
                  fullWidth
                  variant="outlined"
                  testId="borrower-email"
                  type="email"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <ConfirmationButton
                  testId="email-borrower"
                  color="primary"
                  variant="contained"
                  onClick={handleEmailBorrower}
                  fullWidth
                  confirmDialogProps={{
                    title: 'Confirmation',
                    body: 'An email with the payment link will be sent to the borrower. Please confirm.',
                  }}
                >
                  Email Borrower
                </ConfirmationButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );

    const dialogActions = (
      <Button
        testId="close-payment-link"
        color="primary"
        variant="contained"
        onClick={onClose}
      >
        Close
      </Button>
    );

    return (
      <StandardDialog
        open={open}
        title="Payment Link"
        maxWidth="sm"
        handleClose={onClose}
        dialogContent={dialogContent}
        dialogActions={dialogActions}
        removeContentBox
      />
    );
  }
);
